import { GetStaticProps } from 'next';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SWRConfig } from 'swr';

import CpdCourseTsi from '@components/organisms/cpd/courses/tsi';
import cpdAPI, { CPD_END_POINT } from 'src/api/cpd';
import Seo from 'src/components/atoms/seo';
import Main from 'src/components/templates/main';
import config from 'src/config';
import { CPDRegulatorTypeEnum } from 'src/interfaces';

const CpdTsi = ({ fallback }: any) => (
  <SWRConfig value={{ fallback }}>
    <Main scrollToTop isFooterCpd>
      <Seo
        title="หลักสูตรอบรมเก็บชั่วโมงออนไลน์สำหรับผู้แนะนำการลงทุน"
        description="SkillLaneCPD | หลักสูตรอบรมเก็บชั่วโมงออนไลน์ สำหรับผู้ที่ต้องการต่ออายุใบอนุญาต IC / IP / IA รับรองหลักสูตรโดย TSI"
        image_url={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/seo-thumbnail-cpd.jpg`}
      />
      <CpdCourseTsi />
    </Main>
  </SWRConfig>
);

type Params = {
  locale: string;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context as Params;
  const response = await cpdAPI.fetchCPDCourses({ regulatorType: CPDRegulatorTypeEnum.TSI });
  return {
    props: {
      fallback: {
        [CPD_END_POINT.COURSES]: response.data || [],
      },
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: config.REVALIDATE_SHORT,
  };
};

export default CpdTsi;
